export const lang = {
  MINDER_INSPECTION: '曼德全球验货',
  header: {
    Home: '首页',
    Service: '服务',
    Guide: '帮助引导',
    About_us: '关于我们',
    Language: '语言',
    Log_in: '登录/注册',
    Product_Quality_Control: '品控服务',
    Vendor_Assessment_Service: '供应商评估服务',
    Get_started: '快速上手',
    Reference_Cases: '报告样本',
    zh: '中文',
    footer_address: '浙江省杭州市余杭商会大厦D座608室',
  },
  home: {
    Md_Object: '曼德服务对象',
    Why_choose_us: '为什么选择曼德',
    Quality_Control_Team: '强大的品控团队',
    Quality_Control_text:
      '曼德拥有7000+专业品控团队，品控人员来自国际知名贸易集团，第三方公正行。具备丰富的验货经验，提供优秀的品控服务。',
    Response_in_High: '高效及时的反馈结果',
    Response_in_Text:
      '验货期间，您可在线实时浏览报告、无预约24小时内出最终报告。运用交叉管理、实时监控，三方评价等，保证验货结果真实有效。',
    Amazing_Price: '收费透明合理',
    Amazing_Text:
      '无差旅费，无额外费用，只收取固定的检验费用，套餐客户立享5%-10%的优惠。',
    Solutions_Services: '我们的服务',
    Product_Quality_Control: '品控服务',
    Product_Quality_Control_text:
      '  曼德深耕品控体系，凭借资深团队提供优质严格的品控服务。提供组织清晰，内容数字化的品控分析报告。服务包括中期验货，尾期验货，监装监柜。',
    Learn_more: '了解更多',
    Vendor_Assessment: '供应商评估服务',
    Vendor_Assessment_text:
      '拥有一个稳定，高信任度的合作伙伴是商业基础。曼德的质检工程师实地探访您的潜在供应商，多维度真实记录供应商各项数据，为您选择合作伙伴提供可靠数据支持。',
  },
  Register: {
    Mobile_phone: '手机号注册',
    phone_Number_text: '请输入手机号',
    verification_code: '请输入验证码',
    Get_Verified: '获取验证码',
    Please_password: '请输入密码',
    Register: '注册',
    E_mail: '邮箱注册',
    Please_ailbox: '请输入邮箱',
  },
  AboutUs: {
    What_can_we_bring: 'What can we bring to you',
    What_can_text:
      '曼德全球验货（Value Minder) 是一家互联网+品控的第三方检测服务平台，为全世界所有企业客户提供验货、监装、验厂、供应商评估等一系列质量品控服务。将互联网信息技术与传统检测服务相结合，通过智能化平台系统为不同领域的客户提供跨区域的，高效专业的服务，为海内外所有贸易商伙伴创造更高价值。',
    Company_Profile: '公司简介',
    Contact_us: '联系我们',
    Contact_Info: '联系我们',
    OUR_VISION: '企业文化',
  },
  qaQcService: {
    Minder: 'Minder',
    pro_ser: '品控服务',
    pro_good: '助力好品质',
    service_title: '',
    Quality_Control_ServicesOne: '高效服务,专注品控细节',
    Quality_Control_ServicesTow: '告别繁琐流程,轻松一键预约',
    Quality_Control_ServicesThree: '全程专人跟踪,多重审核把控',
    Flexible_response_mechanism: '智能化订单系统',
    Flexible_response_mechanism_text:
      '没有复杂繁琐的流程，智能系统轻松下单只需5分钟',
    Flexible_response_mechanism_text_one: '',
    Save_time: '实时流程管理',
    order_text: '订单系统流程化管理，品控人员在岗检查，',
    order_text_one: '开始/结束定位实时打卡',
    mdservice: '曼德服务',
    anxin: '安心之选',
    The_Best_Quality_Control_One: '强大品控团队',
    The_Best_Quality_Control_text_One: '7000+专业品控人员，确保品质把控专业性',
    The_Best_Quality_Control_Tow: '高弹性反馈机制',
    The_Best_Quality_Control_text_Tow:
      '曼德建立弹性互动系统，从容应对客户即时检验诉求',
    Intelligent_Order_System: '实时流程管理',
    Intelligent_Order_System_text:
      '订单系统流程化管理，品控人员在岗检查，开始/结束定位实时打卡',
    Immediate_Processing_Management: '竞争力的价格体系',
    Immediate_Processing_Management_text:
      '为客户省去大笔差旅，人员费用，创造更高价值',
    Product_Quality_Control_Services: '品控服务',
    Final_Inspection: '尾期验货',
    Final_Inspection_text:
      '在产品生产接近尾声或已完成时对产品进行检验。主要针对即将出货的产品品质进行检验，同时核对产品数量包装细节等。为客户出货决策提供信息支持',
    During_Production_Inspection: '中期验货',
    During_Production_Inspection_text:
      '在产品生产完成了30%-50%左右时对产品进行检验。主要针对产品生产细节，生产进度，技术指标等环节进行特别验视。帮助客户及时对供应商给予指导和调整。',
    Loading_Supervision: '监装监柜',
    Loading_Supervision_text:
      '在货物完成生产，准备出货时进行装柜监督。主要针对货物数量，包装，货柜等信息进行核对。确保出货准确无误。',
    Groceries: '轻工产品领域',
    Groceries_text: '工具，玩具，家具，五金建材，饰品，日常护理品，户外用品等',
    Fabric_Textiles: '面料纺织领域',
    Fabric_Textiles_text: '面料，家纺，纺织品原材料等',
    Garment_Bags: '服饰箱包领域',
    Garment_Bags_text: '服装，配饰，箱包，鞋履等',
    Electronics_Electrical_Equipment: '电子电器领域',
    Electronics_Electrical_text:
      '家用电器，电子信息设备，照明，灯具，电子配件等',
    Product_Inspection_Service: '产品验货服务',
    Get_specific_quote: '立即获取报价',
    Loading_Supervision_Service: '监装监柜服务',
    Best_Service_With_Amazing_Price: '满意的不只有服务',
    start_from: '低至',
    start_from_s: '起',
    money: '¥720',
  },
  Login: {
    Service_Center: '客户平台',
    Log_in: '登录',
    Register: '立即注册',
    Sign_up: '立即注册',
    Forget_password: '忘记密码',
    Home_page: '返回首页',
    Please_Number_mail: '请输入手机号或邮箱',
    Please_input_your_password: '请输入密码',
    err_text: '登录失败',
  },
  menuList: {
    My_Minder: '我的首页',
    Instant_Order: '快速下单',
    Product_Inspection: '验货',
    Product_Inspection_ML:'面料验货',
    Factory_Assessment: '验厂',
    Loading_Supervision: '监装',
    User_Center: '用户中心',
    General_Information: '基本信息',
    My_Wallet: '我的钱包',
    My_Package: '我的套餐',
    My_Coupons: '我的代金券',
    My_Ordre: '我的订单',
    Order_List: '全部订单',
    Uncompleted: '进行中',
    Completed: '已完成',
    Canceled: '已取消',
    Drafts: '草稿箱',
    My_Reports: '我的报告',
    Inspection_Reports: '验货报告',
    My_Review: '我的评价',
    Wait_for_Review: '待评价',
    Reviewed: '已评价',
    current_location: '当前位置',
  },
  menuGoodsSpace: {
    Product_Inspection_text:
      '曼德提供高效，公正的验货服务。只需提供基本验货信息，曼德即快速响应。验货服务包括中期检验、尾期检验、面料检验等',
    Language: '报告语言',
    Chinese: '中文',
    English: '英文',
    Change_Password: '修改密码',
    Log_out: '退出登录',
    Inspection_type: '检验类型',
    Mid_Term_Inspection: '中期验货',
    Final_Inspection: '尾期验货',
    Fabric_Inspection: '面料验货',
    Batch_Inspection: '批量验货',

    //==========验货表单============
    history_orders: '历史订单',
    continue_order: '继续下单',
    Vendor_Information: '工厂信息',
    Factory_Cn: '请填写工厂中文名称!',
    Vendor_Name: '工厂名称',
    Region: '所在区域',
    Please_fill_in_the_region: '请选择所在区域',
    Vendor_Address: '工厂地址',
    Vendor_Address_text: '请填写工厂详细地址',
    Contact_Name: '联系人姓名',
    Please_contact_name: '请填写联系人姓名',
    Telephone: '固话',
    Please_Telephone_number: '请输入座机号: 0000-0000000',
    Mobile: '手机',
    Please_mobile_number: '请填写手机号码',
    E_mail: '邮箱',
    Please_E_mail_Add: '请填写邮箱',
    Company_Profile: '我的信息',
    Company_Name: '公司名称',
    Please_company_Name: '请填写公司名称',
    Company_Address: '公司地址',
    Please_company_Address: '请填写公司地址',
    Product_Details: '产品信息',
    Product_Name: '产品名称',
    Please_product_name: '请填写产品名称',
    Item_Number_Style: '款号/型号',
    Please_product_style: '请填写款号/型号',
    Order_Number: '订单号',
    Please_order_number: '请填写订单号',
    Quantity: '数量',
    Unit: '请填写数量',
    Units: '单位',
    pcs: '件/个',
    pair: '双',
    yard: '码',
    set: '套',
    ctn: '箱',
    Other: '其它',
    Inspection_standard: '检验标准*',
    Inspection_Level: '验收标准*',
    Inspection_levels: '检验水平',
    Inspection_data: '检验资料',
    AQL: '验收标准',
    Critical: '致命缺陷',
    Major: '严重缺陷',
    Minor: '轻微缺陷',
    Inspection_Date: '验货时间',
    Select_date: '请选择日期',
    Please_select_date:
      '若未能确认最终验货日期，可选择预估日期，我司质检人员将于工厂最终确认',
    inspection_files: '检验资料',
    upload: '上传附件',
    upload_text:
      '只支持上传PDF、PPT、Word、Excel、Jpg、jpeg格式,单个附件小于20M',
    Special_Attention: '特别注意点',
    Please_special_attention: '请填写特别注意点',
    Generating_orders: '生成订单',
    Add_to_draft: '加入草稿箱',
    product: '产品',
    //面料
    Color: '颜色',
    Please_fill_in_color: '请填写颜色',
    Dimension: '尺寸',
    please_fill_in_dimension: '请填写尺寸',
    Weight: '重量',
    please_fill_in_weight: '请填写重量',
    Material: '材质',
    please_fill_in_material: '请填写材质',
    point_system: '(四分制评分法)',
    Max_penalty_points_text: '每100平方码平均罚分不得大于',
    Max_penalty_points: '每100平方码1分疵点罚分不得大于',
    It_will_be_judged:
      '无论罚分多少，如不合格卷/匹总长度超过检验总长的的10%，则检验结果判定为不合格',
    Confirm_the_Order: '生成订单',
    Order_details: '订单详情',
    Factory_Evaluation: '质量验厂',
    Vendor_Assessment: '供应商评估',

    With_Minder_Loading_Supervision:
      '曼德监装服务确保您的货物能够在正确的时间足额足量的装箱入柜',
    Container: '集装箱',
    Container_Information: '集装箱信息',
    Loading_Quantity: '装柜数量',
    Arrival_time: '到达时间',
    Please_fill_in_Arrival_time: '请填写到达时间',
    Loading_can_only:
      '监装时间必须大于装箱到达时间，凡因为货车因故晚点8小时及以上或者工作时长超过8小时，需支付额外一人天费用',
    Minder_provides_professional:
      '曼德为全球客户提供专业的验厂服务，让您足不出户即可清晰了解目标供应商的一切基本信息。',
    Please_select_estimated:
      '若未能确认最终验货日期，可选择预估日期，我司质检人员将于工厂最终确认',
  },
  UserCenter: {
    /*============基本信息=================*/
    General_Information: '基本信息',
    Security_Level: '安全等级',
    Company_Profile: '企业资料',
    E_mail: '邮箱',
    Unverified_Email: '尚未绑定任何邮箱',
    Fix_Now: '绑定邮箱',
    Password: '密码',
    Please_set_your_password: '请设置密码',
    update: '修改',
    Please_enter_your_mailbox: '请输入邮箱',
    Please_enter_your_mailbox_address: '请输入邮箱地址',
    Please_enter_the_verification_code: '请输入验证码',
    Get_the_authentication_code: '获取验证码',
    cancel: '取消',
    Immediate_binding: '立即绑定',
    Modify_login_password: '修改登录密码',
    Please_enter_the_original_password: '请输入原密码',
    Check_text:
      '请输入数字，大写字母，小写字母，特殊字符四选三组成的密码强度，且长度在8到30个数之间密码',
    Check_New_password: '请输入新密码',
    Check_password_tow: '请再次输入新密码',
    confirm_update: '确认修改',
    /*============安全等级=================*/
    Your_Security_Level: '您的安全等级',
    Log_in_password: '登录密码',
    pay_password: '支付密码',
    Get_your_password_more_secure: '提升密码安全程度',
    Settings: '设置',
    Verify_your_mobile_number: '验证手机号',
    Verify: '验证',
    Rebind_mailbox: '重新绑定邮箱',
    Company_files: '公司资料',
    Improve_account_level: '用于提升账号的安全和信任级别',
    Modify_Payment_Password: '修改支付密码',
    Please_enter_digit_payment_password: '请输入6位数字的支付密码',
    If_payment_password: '如果支付密码未设置,可以为空。',
    please_payment_password: '请输入6位数字的支付密码',
    Clear: '取消',
    Mobile_phone_number_verification: '手机号码验证',
    Please_phone_number: '请输入手机号',
    Mailbox_Verification: '邮箱验证',
    /*============企业资料=================*/
    Company_Profile_t: '公司资料',
    Photo: '头像',
    Company_Name: '公司名称',
    please_company_name: '请填写公司名称',
    Region: '所在区域',
    Please_region: '请选择所在区域',
    Sepecific_Add: '所在地址',
    Please_ADD: '请输入所在地址',
    Contact_Name: '联系人姓名',
    Please_contact_name: '请输入联系人姓名',
    Mobile_Number: '联系人手机号',
    Telephone_Number: '联系人固话',
    Please_Tel_Number: '请输入联系人固话',
    Licence_registration: '营业执照注册号',
    Please_License_Number: '请填写营业执照注册号',
    Licence: '营业执照',
    update_imaeg_text: '1、2M以内，JPG/PNG格式',
    Company_text: '2、我司资质验证系统已与工商部门联网，请勿提供虚假证件',
    Company_text_tow: '2、请勿提供虚假凭证，否则认为支付失败。',
    Submit: '提交信息',
    /*============我的钱包=================*/
    My_Wallet: '我的钱包',
    Balance: '余额',
    Recharge: '充值',
    My_Coupons: '我的代金劵',
    Account_Details: '钱包明细',
    Date: '时间',
    Details: '详情',
    Account_Change: '钱包变化',
    Account_Balance: '钱包余额',
    Income: '我的收入',
    Expenditure: '我的支出',
    //我的套餐
    My_Package: '我的套餐',
    Package_List: '套餐列表',
    Purchase_Record: '购买记录',
    Consume_Record: '使用记录',
    Item_Nr: '序号',
    Package_Nr: '套餐编号',
    Package: '套餐名称',
    Original_rem: '原价(¥)',
    Original_ub: '原价($)',
    Package_Price_rem: '套餐价(￥)',
    Package_Price_ub: '套餐价($)',
    Total_MD: '使用次数（人/天）',
    Operate: '操作',
    Check_out_now: '立即支付',
    Confirm: '确定',
    Cancel: '取消',
    Package_Order_Nr: '套餐订单号',
    Service_Date: '使用日期',
    Service_Order_Nr: '使用订单号',
    Purchase_Date: '购买日期',
    Quantity: '购买数量',
    Sum: '支付金额',
    Status: '状态',
    Voucher: '支付凭证',
    //我的代金劵
    // My_Coupons: '我的代金劵',
    Available: '可使用',
    Used: '已使用',
    Expired: '已过期',
    Click_to_use: '点击使用',
    Get_when_registed: '注册获得',
    Validity_Time: '有效期',
    /*============充值=================*/
    Select_Currency: '选择币种',
    Charge_RMB: '人民币充值',
    Charge_USD: '美元充值',
    Select_Amount: '充值项目',
    Payment_Method: '支付方式',
    Alipay: '支付宝',
    Wechat_Pay: '微信',
    Total_Amount: '应付金额',
    Unit: '¥',
    Ather_Amounts: '其他金额，金额需大于100元',
    _Submit: '充值',
  },
  No_data: '暂无数据',
  // 我的订单
  orderAll: {
    // 全部订单
    Order_List: '全部订单',
    Order_Number: '订单',
    Order_Type: '订单类型',
    Service_Date: '服务日期',
    Factory_sel:'工厂',
    PO_Number:'采购订单号',
    Product_Name:'产品名称',
    Item_Number:'产品款号/型号',

    Order_status: '订单状态',
    Serach: '搜索',
    Vendor_name: '工厂',
    Order_date: '下单日期',
    Service_fee: '服务费用',
    Total_MD: '总人天数',
    Operate: '操作',
    Serial_Number: '序号',
    Uncompleted: '未完成',
    Completed: '已完成',
    Canceled: '已取消',
    Drafts: '草稿箱',
    search: '搜索',
    Select_the_order_type: '请选择订单类型',
    Select_the_date: '请选择日期',
    Select_the_order_status: '请选择订单状态',
    Pay: '立即支付',
    View_Report: '查看报告',
    down_Report: '下载报告',

    Edit: '立即编辑',
    Cancel: '取消订单',
    Recover: '恢复订单',
    Delete: '删除订单',
    View: '查看',
    Review: '立即评价',
    To_be_confirmed: '待确认',//0待确认
    To_be_paid: '待付款',//1待付款
    To_be_assigned: '待匹配',//2待匹配
    Order_release: '发布中',//3发布中
    To_be_served: '待服务',//4待服务
    Under_inspecting: '服务中',//5服务中
    Under_auditing: '审核中',//6审核中
    To_be_translated: '待翻译',//7待翻译
    To_be_reviewed: '待评价',//8待评价
    Finished: '已完成',//9已完成
    Draft: '草稿箱',//10草稿箱
  },
  //我的报告
  Reports: {
    Inspection_Reports: '验货报告',
    System_order_Nr: '系统订单号',
    sys_nr:'系统服务单号',
    Order_Nr: '采购订单号',
    Service_Date: '服务日期',
    Report_Date: '报告日期',
    Start_from: '开始时间',
    End: '结束时间',
    // Inspection_Reports: '验货报告',
    Nr: '序号',
    Report_Nr: '报告',
    Customer: '用户',
    Category: '产品分类',
    Factory: '工厂',
    Service_data: '服务时间',
    Total_MD: '总人天数',
    // Order_Nr: '订单号',
    Report: '订单报告',
  },
  // 我的评价
  Review: {
    Wait_for_Review: '待评价',
    Reviewed: '已经评价',
    Quality_Engineer: '人员名称',
    Order_Type: '订单类型',
    Nr: '序号',
    Time_keeping: '守时分数',
    professional_ethics: '道德分数',
    Skill: '专业分数',
    Communication: '沟通配合分数',
    Communications: '沟通配合',
    Order_Nr: '订单号',
    Comment: '评语',
    Operate: '操作',
    Save: '立即保存',
    Inspector_Rate: 'QC评价',
    Service_Rate: '客服评价',
    Inspector_ID: 'QC工号:',
    Customer_Service_ID: '客服工号:',
    Back: '返回',
  },
  // 支付方式页面
  payType: {
    Balance_on_Account: '余额支付',
    Pay_in_RMB: '人民币支付',
    Pay_in_USD: '美元支付',
    Pay_in_Package: '套餐支付',
    System_Order_Nr: '系统订单号',
    Package: '套餐名称',
    Order_Type: '订单类型',
    Report_Type: '报告类型',
    Amount: '等待支付',
    PayPal_Surcharge: '汇率手续费',
    Payment_currency: '支付币别',
    Coupon: '代金券',
    Not_Available: '暂无可用',
    Valid_Till: '截止日期',
    Final_Payment: '实际支付',
    Renminbi: '人民币',
    U_S_dollar: '美元',
    Payment: '支付方式',
    Surplus: '余',
    Optional_package: '可选套餐',
    MD: '人/天',
    Bank_Transfer: '线下支付',
    Photo_Bank_required: '需上传银行回执照片汇款手续费自理',
    Submit: '立即付款',
    Wechat_Pay: '微信支付免',
    with_no_extra_cost: '汇款手续费',
    Alipay: '支付宝支付免',
    PayPal: 'PayPal',
    Extra_text: '加收4.5%汇款手续费',
    Pay_with_Account_Balance: '使用账户余额支付,账户余额',
  },
  // 支付弹框
  payModule: {
    Please_finish_payment_page: ' 请在新开页面完成付款',
    pay_module_text:
      '付款完成前请不要关闭此窗口，完成付款后请 根据您的情况点击下面的按钮。',
    Done: '已完成付款',
    Need_help: '付款遇到问题',
    Sorry_payment: '抱歉，付款失败',
    Please_service_contact: '请稍后再试或联系客服:',
  },
  //我的报告详情
  ReportsDetail: {
    GENERAL_INFORMATION: '基本资料',
    Client_Name: '客户名称：',
    Factory_Name: '供应商名称：',
    Factory_Address: '供应商地址：',
    Product_Name: '货品名称：',
    PO_Number: '订单号：',
    Item_Number: '货品款号/型号：',
    Order_Quantity: '订单数量：',
    Actual_Shipment_Quantity: '实际出货数量：',
    Inspector_s: '验货员：',
    Factory_Representative: '供应商代表：',
    Inspection_Started_at: '验货开始时间：',
    Inspection_Completed_at: '验货结束时间：',
    Product: '产品图片',
    Cleargov: '廉政申明及抽样封箱',
    Factorycard: '厂牌',
    Remarkphoto: '备注图片',
    BULK_SUMMARY: '货物描述',
    Packed: '大货箱堆：',
    Unpacked: '未入箱成品：',
    Semi_finished: '半成品：',
    Sambox: '抽样箱堆：',
    Samproduct: '抽样产品：',
    Remarks: '大货完成概况：',
    P_O_Number: '编号',
    Product_name: '产品名称',
    Completed_quantity: '已完成数量',
    packed: '入箱成品数量(pcs)',
    unpacked: '未入箱成品数量(pcs)',
    Total_Carton: '成箱箱数',
    Semi_finished_Quantity: '半成品数量',
    ActualShipmentQuantity: '实际出货数量',
    PACKING_INFORMATION: '包装描述',
    Batch_1: '第一款',
    Batch_2: '第二款',
    Batch_3: '第三款',
    Batch_4: '第四款',
    Batch_5: '第五款',
    Batch_6: '第六款',
    Batch_7: '第七款',
    Batch_8: '第八款',
    Batch_9: '第九款',

    Carton_Seal: '外箱包装方式：',
    Main_Mark: '外箱正唛：',
    Side_Mark: '外箱侧唛：',
    Carton_barcode: '外箱条码：',
    Carton_Size: '外箱尺寸：',
    Carton_Weight: '外箱重量(带产品)：',
    Inner_Packing: '开箱后包装：',
    Corrugated_Layer: '外箱瓦楞质量：',
    Inner_Box: '内盒：',
    Inner_Packing_Details: '单件产品包装方式/细节：',
    Inner_Packing_Size: '单件产品包装尺寸：',
    Accessory_Manual_Polybag: '其他：',
    CartonSize: '外箱尺寸',
    CartonWeight: '外箱重量',
    Packing_Detail_For_Shipping_Carton: '大货包装方式',
    Unit_Packing_Detail: '单件产品包装方式',
    Product_Packing_Size: '单件产品包装尺寸',
    WORKMANSHIP: '产品工艺',
    Defect_Description: '疵点描述：',
    Defect_Quantity: '瑕疵品数量：',
    Defects: '等级：',
    Remark: '疵点备注：',
    Defect: '瑕疵品照片：',
    Critical: '严重',
    Major: '主要',
    Minor: '次要',
    DEFECTS_DISPOSAL: '瑕疵品处理',
    Defective_Product_Area: '瑕疵品堆放区：',
    Vendor_Representative_Confirmed: '负责人与瑕疵品合影：',
    QC_Confirmed: 'QC与瑕疵品合影：',
    Untreated: '无法处理',
    Cancel: '报废：',
    Rework: '现场处理：',
    Nr: '疵点编号',
    DefectDescription: '瑕疵描述',
    Data_records: '数据记录(件)',
    DefectQuantity: '次品数',
    rework: '现场处理',
    replace: '承诺处理',
    cancel: '报废退回',
    Product_Details: '产品细节',
    Front: '正面：',
    Side: '侧面：',
    Back: '内部：',
    Inside: '内部',
    Details: '细节(印花/绣花/辅件/添加要求)：',
    Product_Measurements: '产品尺寸：',
    Contrastphoto: '大货与签样对比：',
    Main_Product_Size: '主产品尺寸记录',
    productName: '产品名称',
    Length: '长',
    Width: '宽',
    Height: '高',
    Weight: '重量',
    Accessory: '配件',
    Size: '尺寸(A*B*C)',
    TEST: '现场测试/数据记录',
    Test_photo: '照片',
    Field_Test: '测试项目：',
    Test_Requirement: '测试要求：',
    Quantity: '抽样数量：',
    Conclude: '结论：',
    Brief_Report: '总概',
    Overall_Conclusion: '总体结论',
    PASS: '通过',
    PENDING: '待定',
    FAIL: '不通过',
    Brief_Findings: '综合简报',
    Bulk_Summary: 'A.货物描述',
    Packing_Information: 'B.包装描述',
    Workmanship: 'C.产品工艺',
    ProductDetails: 'D.产品细节',
    Data_Measurement_Field_Test: 'E.现场测试/数据记录',
    Defects_Disposal: 'F.瑕疵品处理',
    Pass: '符合',
    Pending: '待定',
    Fail: '不符合',
    Description: '相关描述',
    Customer_Requirements: '特别关注',
    Reply: '回复',
    Return: '立即返回',
    Descriptions: '品项描述',
    Unfinished: '未完成数量(pcs)',
  },
  //监装报告详情
  LoadingReport: {
    GENERAL_INFORMATION: '基本信息',
    Client_Name: ' 客户名称',
    Loadig_Address: '监装地址 ',
    PO_Number: '订单号',
    Item_Number: '产品款号/型号 ',
    Product_Name: '产品名称',
    Inspector_s: '监装员 ',
    Inspection_Started_at: '监装开始时间',
    Inspection_Completed_at: '装运完成时间',
    Container_Type: '集装箱类型',
    Container_Condition: '柜体情况',
    Container_No: '货柜号',
    Seal_Number: '铅封号',
    Loading_Quantity: '装柜数量',
    Gates: '工厂大门',
    Packed: '大货箱堆',
    Unpacked: '未入箱成品',
    Semi_finished: '半成品',
    Completed: '已完成数量',
    Uncompleted: '未完成数量',
    Quantity_pcs: '已完成产品数',
    Cartons_CTN: '已完成箱数',
    Quantity_pcs1: '未完成产品数',
    Cartons_CTN1: '未完成箱数',
    Packing_Information: '货物包装',
    Carton_Seal: '外箱封装方式',
    Front_Mark: '外箱正唛',
    Side_Mark: '外箱侧唛',
    Carton_barcode: '外箱条码',
    Carton_Size: '外箱尺寸',
    Carton_Weight_Gross: '外箱重量（带产品)',
    Inner_Packing: '开箱后包装',
    Corrugated_Layer: '外箱瓦楞质量',
    Inner_box: '内盒',
    Packing_Details_Single_unit: '单件产品包装方式/细节',
    Others_Accessory_Manual_Polybag:
      '其他（零配件/说明书/胶带/彩盒/内盒条码/添加要点)',
    Product_Details: '装箱产品',
    Front_View: '产品正面',
    Side_View: '产品侧面',
    Back_View: '产品背面',
    Inside_View: '产品内部',
    Details: '产品细节',
    Product_Color: '产品颜色对比',
    Truck_And_Container: '拖车货柜',
    Truck_Front: '货柜车前面照',
    Licence: '车牌',
    Container_Side: '货柜侧面',
    Container_Inside_Check: '装柜前柜内检查',
    Container_No_Inside: '货柜内壁柜号',
    Container_No_Outside: '货柜外壁柜号',
    Truck_Badge_Back: '货柜车尾照',
    Loading_Process: '过程监控',
    Order_Quantity_pcs: '计划发货数量（pcs）',
    Order_Cartons_CTN: '计划发货箱数（CTN）',
    Actual_Loaded_Quantit_pcs: '实际发货数（pcs）',
    Actual_Loaded_Cartons_CTN: '实际发货箱数（CTN）',
    Container_Sealing_Photo: '封柜照片',
    Loading_quarter: '装柜过程（1/4）',
    Loading_half: '装柜过程（1/2）',
    Loading_three_quarter: '装柜过程（3/4）',
    Loading_Finished: '全部装完 ',
    Right_Door_Closed: '右侧柜门关闭',
    Both_Door_Closed: '双侧柜门关闭',
    Seal_Container: ' 封柜 ',
    Seal: '铅封',
    Seal_No: '铅封号',
    Brief_Report: '总概',
    Overall_Conclusion: '总体结论',
    PASS: '通过',
    PENDING: '待定',
    FAIL: '不通过',
    Brief_Findings: '综合评判',
    Loading_Quantity1: 'A.装柜数量',
    Packing_Information1: 'B.货物包装',
    Product_Details1: 'C.装箱产品',
    Truck_And_Container1: 'D.拖车货柜',
    Loading_And_Stuffing: 'E.过程监控',
    Container_Sealing: 'F.封柜',
    Conform: '符合',
    Pending: '待定',
    Not_Conform: '不符合',
    Customer_Requirements: '特别关注',
    Loading_Finished_Photo: '大货装柜完成图片',
    Remark: '备注',
  },
  //面料报告详情
  FabricReport: {
    GENERAL_INFORMATION: '基本信息',
    Client_Name: '客户名称',
    Factory_Name: '工厂名称',
    Factory_Address: '工厂地址',
    PO_Number: '订单号',
    Product_Name: '产品名称',
    Style_Model_Number: '产品款号/型号',
    Order_Quantity: '订单数量',
    Documents: '工厂提供资料',
    Inspectors: '验货员',
    Factory_Representative: '工厂代表',
    Inspection_Started_at: '验货开始时间',
    Inspection_Completed_at: '验货结束时间',

    BULK_SUMMARY: '大货情况',
    Packed: '大货成卷卷堆',
    Unpacked: '未成卷产品',
    Packed1: '已包装',
    Unpacked1: '未包装',
    Packing_List: '码单',
    Color: '颜色',
    Ticket_Length: '订单长度',
    Actual_Length: '实际出货长度',
    Sample_Length: '抽检长度',
    Roll_Qty: '卷数',

    PACKING_INFORMATION: '包装情况',
    Roll_Packed_Details: '单卷面料封装方式',
    Shipping_Mark_Lable: '唛头及产品标签',
    Inner_Packing_Details: '开包装产品展示',
    Collateral_Others: '辅料/产品细节展示',
    Confirmed_packing_information: '是否提供包装资料对比',
    yes: '是',
    no: '否',

    WORKMANSHIP: '产品工艺',
    Dye_Lot: '缸号',
    Roll_Number: '卷号/颜色',
    Defect_Description: '疵点描述',
    Points: '罚分',
    Defect: '疵点照片',

    Product_Width: '产品门幅',
    Full_Width: '全门幅',
    Cuttable_Width: '可裁门幅',

    DATA_MEASUREMENT_FIELD_TEST: '现场测试/数据记录',
    Test_Item: '测试项目',
    Date_Records: '数据记录',
    Conclusion: '是否通过',
    Test: '测试照片',
    Remarks: '备注',

    DEFECTIVES_LIST: '四分制评分表',

    Brief_Findings: '综合简报',
    A_Bulk_Summary: 'A. 大货情况',
    B_Packing_Information: 'B. 包装情况',
    C_Workmanship: 'C. 产品工艺',
    D_Product_Width: 'D. 产品门幅',
    E_Data_measurement_Field_test: 'E. 现场测试/数据记录',
    F_Defects_List: 'F. 4分制评分表',
    Conform: '符合',
    Not_Conform: '不符合',
    Pending: '待定',
  },

  //验厂报告详情
  factoryReport: {
    General_Information: '基本信息',
    Client_Name: '客户名称',
    Factory_Name: '工厂名称',
    Business_License_Address: '工厂注册地址',
    Actual_Factory_Address: '工厂实际地址',
    Conform: '相符',
    Not_Conform: '不符',
    Factory_Legal_Person: '法人姓名',
    Factory_Ownership: '工厂所有权',
    Factory_Established_At: '工厂成立时间',
    Business_License_valid_till: '工商执照有效期',
    Business_License_Number: '工商营业执照号码',
    Registered_Capital: '注册资本',
    Main_Product: '主营产品',
    Website: '网址',
    Main_Market: '主要市场',
    Service_data: '服务时间',
    Annual_Audit: '年审情况',
    Annual_Output: '年产值',

    Business_License: '营业执照',
    Factory_Property_Ownership_Certificate: '房产证文件',
    Tenancy_Agreements: '租赁合同',
    ID_Card_Of_The_Legal_Person: '法人身份证（正反）',
    Company_Awards: '企业荣誉证书',

    Production_Capability: '产品信息',
    Product_Catalogue: '产品目录',
    Product_Quality_Certificate: '产品认证证书',
    Products_Awards: '产品荣誉证书',
    Brochure: '产品宣传册',
    Client_Product_reference: '客户大货',

    Workshop_Plant_Overview: '操作环境',
    Factory_Area: '厂区总面积',
    Office_Area: '办公区域面积',
    Workshop_Area: '生产车间面积',
    Raw_Material_Warehouse_Area: '原料仓库面积',
    Products_Warehouse_Aera: '成品仓库面积',
    Showroom_Area: '样品室面积',
    Factory_Environment: '厂区环境',
    Clean: '整齐',
    Dirty: '杂乱',
    remarks: '备注:',
    Gate: '工厂大门',
    Office: '办公区域',
    Showroom: '样品室 ',
    Workshop: '生产车间',
    Raw_Material_Warehouse: '原料仓库',
    FG_Warehouse: '成品仓库',
    Staff_Dormitory: '员工宿舍楼',
    Canteen: '食堂',
    Factory_Infirmary: '医务室',

    Equipments_Information: '设备信息',
    Equipment_Name: '设备名称',
    Model_Nr: '设备型号',
    Quantity: '数量',
    Maintenance_Records: '保养（维护）记录 ',
    Yes: '有',
    NO: '没有',
    Equipment_List: '设备清单',
    Equipment: '设备照片',

    Production_Manufacturing_Process: '生产流程',
    Production_Line: '生产线',
    Automatization: '自动化程度',
    Full_automatic: '全自动',
    Semi_automatic: '半自动',
    Production_Line_Quantity: '生产线数量',
    Staff_Quantity: '在线员工数量',
    Yearly_Output: '年产量',

    Human_Resourse_Records: '人力资源',
    Staff_Registered: '花名册数量',
    Staff_on_Duty: '实际数量',
    Management: '管理层',
    Product_Department: '生产部',
    Logitics_Division: '物流部',
    Busiess_Department: '业务部',
    Research_and_Development_Department: '研发部',
    Admiistrative_Department: '行政后勤',
    Others: '其它（临时职员）',
    All: '总计',
    Staff_List: '员工花名册',
    Staff_Archives: '员工档案记录',
    Recent_Months_Attendance: '近3个月考勤记录',
    Recent_Months_Salary: '近3个月工资记录',

    Operation_Records: '企业运营记录',
    Tax_Bill_Recent_Month: '近3个月纳税申报表',
    Rent_Records: '近3个月房租缴纳凭证',
    Utility_bills: '近3个月水电缴纳凭证',
    Material_Input_Invoices: '近6个月原料进项发票',
    Output_Invoices: '近6个月销项发票',
    Material_Warehouse_Records: '原料仓库进出货记录',
    Product_Warehouse_Records: '成品仓库进出货记录',
    Bill_of_Material: '产品BOM物料清单',
    Production_Plan: '生产计划单',
    Production_Summary: '生产报表',
    Inspection_Records: '品质检验记录',
    The_factory_failed: '工厂未能提供文件资料清单',

    Conclusion: '总概',
    Advantage: '优势',
    Disadvantage: '劣势',
  },
  myHome: {
    //新增
    Report_To_Be_Done: '报告待办',
    Order_To_Be_Done: '订单待办',
    Chinses_Package_Balance: '中文套餐余额',
    English_Package_Balance: '英文套餐余额',
    Available_Coupons: '可用优惠券',
    Buy_Package: '购买套餐',
    Zhang: '张',
    Balance_Unit: '人天',
    now: '立即',
    order: '下单',
    Product: '验货',
    Factory: '验厂',
    Supervision: '监装',
    Fabric: '面料',
    Username: '用户名称',
    More: '更多',
    Pay: '支付',
    Cancel: '取消',
    Edit: '编辑',
    Delete: '删除',
    Recover: '恢复',
    View: '查看',
    RECOVER_Order: '确定要恢复订单吗？',

    Order_List: '订单列表',
    Account: '账户信息',
    Report_Overview: '报告速览',
    Account_Balance: '账户余额',
    Plan_Balance: '套餐余额',
    CN_Plan: '中文',
    EN_Plan: '英文',
    Coupons: '代金券',
    DELETE_Order: '确认要删除订单吗？',
    CANCEL_order: '确认要取消订单吗？',
    Download: '下载',
  },
  Category: {
    Groceries: '轻工产品类',
    Electronics: '电子电器类',
    Fabric: '面料纺织品类',
    Garment: '服装服饰类',
  },

  BarOther: {
    home: '首页',
    service: '服务',
    quality: '质量品控',
    rkkw9t: '集装箱监装',
    oww1lo: '供应商评估',
    vwiq99: '新产品开发',
    fuaoau: '用户指引',
    q618ep: '联系我们',
    iqp9rr: '登录',
    b2xprb: 'EN',
  },
  FooterOther: {
    zs3eck: '微信扫码预约服务',
    ktb2ur: 'Minder Inspection',
    '6yyjjc': 'Works with Minder, Minder Works',
    re5sad: '曼德品控',
    usnxbi: '联系我们',
  },
  main: {
    '1dt1j2': '质量无小事，曼德来守护',
    quailty: '曼德提供可靠的质量品控服务，供应商评估服务',
    pczd9p: '登录',
    '7rbwz7':
      '曼德品控是一家互联网+品控的第三方检测服务平台，曼德提供验货、监装、验厂、供应商评估，新产品开发等一系列质量品控服务。将互联网信息技术与传统检测服务相结合，通过智能化平台系统为不同领域的客户提供跨区域的，高效专业的服务，为海内外所有贸易商伙伴创造更高价值。',
    d5ccl3: '品质服务',
    hb3x95:
      '曼德以一种全新的方式来追踪质量控制流程，凭借优质的服务体验让用户更高效，更方便的掌控质检流程，并最终提升整体竞争力。',
    ss10g8: '质量品控服务',
    jspb3m: '更多',
    u44avv: '供应商评估',
    cpnavt: '集装箱监装',
    xf74pb: '新产品开发',
    qlu4ej: '核心价值',
    '1bfizf': '专业品控团队',
    me37mm:
      '曼德拥有专业品控团队，品控人员来自国际知名贸易集团，第三方公正行。具备丰富的行业经验，提供优秀的品控服务。',
    cb2q1j: '跨越空间屏障，不受时间束缚',
    var86x:
      '不再担心异地出差的路途劳顿，无论路途再远，时间再紧，无须亲自赶赴，我们帮您搞定。',
    nwz8j7: '经济高效，超高性价比',
    rto9zc: '为客户省去大笔差旅，人员费用，创造更高价值',
    wkmsf4: '数字化品控成就高品质的报告出品',
    '25f6ak':
      '我们在审查过程中重视数据收集，每一个模块都有具体数据支撑，眼见为实。 量化报告，重点清晰易读。',
    p4586r: '轻松开启曼德服务',
    jtdq0u: '登录',
    f3oiph: '登录曼德品控验货智能系统，告别繁琐流程,轻松一键预约',
    v3ojm4: '想要查看我们的输出内容？',
    b1u9xm: '接收我们的样板报告',
    okn6an: '在此输入您的邮箱',
    u5asdi: '提交',
  },
  quailty: {
    '0mal0f': '质量品控服务',
    po356y: '中期检验',
    '26c0pu':
      '在产品生产完成了30%-50%左右时对产品进行检验。主要针对产品生产细节，生产进度，技术指标等环节进行特别验视。帮助客户及时对供应商给予指导和调整。',
    '5k1ybr': '出货前检验',
    ttza9v:
      '在产品生产接近尾声或已完成时对产品进行检验。主要针对即将出货的产品品质进行检验，同时核对产品数量 ，包装细节等。为客户出货决策提供信息支持',
    okc6nf: '服务领域',
    wssl3q: '工具，玩具，家具，五金建材，饰品，日常护理品，户外用品等',
    kb9sl6: '轻工产品',
    rgkx6g: '面料，家纺，纺织品原材料等',
    d94vs5: '面料纺织品',
    qtay9t: '服装，配饰，箱包，鞋履等',
    wdw9wg: '服饰箱包',
    dq5hgi: '家用电器，电子信息设备，照明，灯具，电子配件等',
    fndilq: '电子电器',
    yovmva: '满意的不只有服务',
    h4zdms: '发起计划',
  },
  container: {
    r3687u: '集装箱监装',
    ociaza:
      '在货物完成生产，准备出货时进行装柜监督。主要针对货物数量，包装，货柜等信息进行核对。确保出货准确无误',
    qmk06r:
      '为了防范运过程中可能出现的货物损伤，曼德质检工程师会在装柜过程中引导装运人员，以更合理更安全的方式装柜',
    uhc0i8: '核心价值',
    uiovue: '确保货物装上货柜的过程中搬运妥当',
    ykb6cu: '确认装入集装箱中的产品与装箱单数据相符合，没有错装，短装',
    t76xgv: '核对产品实际包装与合同要求的相符合',
  },
  vendor: {
    '2ikbjo': '供应商评估',
    c4qsgh: '想要深入了解您的潜在供应商？',
    ja3s8r: ' 优化供应商管理系统，我们提供更好的方案！',
    zxy9bc: '清晰识别供应商',
    yewaw8:
      '多维度，深层次挖掘供应商能力 洽谈合作，运筹帷幄 细致展现真实可靠的数据， 为您的决策带来实实在在的支持',
    qnzcvs: '精耕细分市场',
    v4f2fg:
      '行业不同，从业人员所需配备的行业背要，专业知识各异。曼德精确识别细分行业，评估分析更准确',
    '2lrzjb': '高效快捷，精准决策',
    '4ez0fi':
      '基于曼德流程化的服务系统，我们以最快速度将您呈现供应商资质报告让您能够在短时间内掌握多个供应商情况，您的决策将无比准确，快速',
    '3a65tn': '主要功能',
  },
  product: {
    asifsf: '新产品开发',
    '5e2vvj':
      '新产品开发过程中通常需要与工厂开发团队保持高频次的沟通，还需要往返工厂进行技术细节的商讨，费时费力。曼德提供全流程的产品开发协助',
    '4ebm8s': '保持新品按照既定计划上市',
    gsfl38:
      '通常我们开始一个新产品开发流程时，需要进行多轮样品试制。在进行与工厂的来回沟通',
    nf0053:
      '根据买家与工厂的沟通记录，曼德工程师会实地前往工厂检查样品并记录新一轮样品的实际情况',
    csgmvo: '开发',
    ie98hv: '流程',
    a9sghc: '产品设计与原型样制作',
    zztqn9: '产品原型需要经过几轮的打磨，期间需要双方细致的沟通反馈',
    kbjhoe: '产品测试',
    jilwi4: '产品原型需要经过严格的测试，例如功性能测试，材料实验室测试等',
    urjj9c: '开模',
    '43jimm':
      '当最终的所有细节都得到确认后，一些部件需要制作特定的模具（制具）',
    hdanvk: '产前样评审',
    '5mucjv': '在很多产品开发实例中，产前样是进入大货生产前最重要的步骤',
  },
  guide: {
    '6utg29': '用户指引',
    '3proyr': '只需要简单的几步就能接入曼德订单系统',
    r9gfva: '快速接入',
  },
  FQA: {
    '1ny4sh': 'Facts &',
    '0bdyn9': 'Questions',
    juuubr: '曼德提供什么服务',
    j371ii: '订单价格如何核算？',
    m63h4i: '可以使用哪些支付方式?',
    '6a7k58': '曼德相较竞争对手有哪些优势?',
    cida7w: '支持取消订单吗？',
    wptwf3:
      '曼德品控帮助海外买家更好的控制产品品质，提供验货、监装、验厂、供应商评估，新产品开发等一系列质量品控服务',
    '3lr87o': '目前订单支付支持RMB 或 USD 双币种支付。 支持的支付方式包括：',
    '3lr8733':
      ' 1. 套餐余额 2. 支付宝扫码 3. 微信扫码 4. PayPal 5. 线下银行转账',
    xzgjmq:
      '曼德的服务价格以人/天（MD）为单位。客户在新建订单时会看到对应服务的标准单价（1MD） 。根据客户提交的订单资料，曼德会联系客户针对验货细节进行核实并对不同的订单进行报价。因而不同的订单可能会有不同的价格。',

    grrsci: '曼德品控服务相较于竞争对手，主要优势： ',
    grrsci1:
      '1. 曼德深耕制造业品控体系，通过长期的用户需求研究，对贸易商，出口商的品质痛点做出重点关注。',
    grrsci2:
      ' 2. 我们在审查过程中重视数据收集，每一个模块都有具体数据支撑，眼见为实。 量化报告，重点清晰易读。 ',
    grrsci3:
      '  3. 曼德提供优质服务的同时，保持高竞争力的价格。同时套餐客户享有折上折。',

    rni8xf:
      '支持。 在未履行服务前，客户有权取消订单。如需取消订单，请至“我的订单”中进行操作。也可联系您 的专属客户经理进行处理。',
    '68lado':
      '支持。 在未履行服务前，客户有权取消订单。如需取消订单，请至“我的订单”中进行操作。也可联系您 的专属客户经理进行处理。',
  },
  contact: {
    '44bpko': '联系我们',
    tip01: '请输入合法的邮箱',
    '8b7im3': '姓名',
    '6zh5n2': 'Email',
    ujdprn: '内容',
    aes7hy: '提交',
  },
};
